import t from "@/lang/lang";
import { useGfsCatalogGetQuery } from "@/services/backend/gfs/catalog/api";
import { GfsMeasurePricingEditor } from "@/services/backend/gfs/calculation/components/calculation-editor";
import { useGfsOfferEditorContext } from "@/services/backend/gfs/offer/components/offer-editor-context";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function GfsOfferCalculationPage() {
  const { offer, putRequest, saveState, updateCalculation } =
    useGfsOfferEditorContext();
  const { data: catalog } = useGfsCatalogGetQuery(
    { id: offer.calculation.catalogId ?? "" },
    { skip: !offer.calculation.catalogId },
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Kalkulation")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-5 pb-16">
        <GfsMeasurePricingEditor
          catalog={catalog}
          pricing={offer.calculation.pricing}
          value={putRequest.calculation}
          disabled={offer.immutable}
          saveState={{
            error: saveState.error,
            successKey: saveState.data,
          }}
          onChange={updateCalculation}
        />
      </CardContent>
    </Card>
  );
}
